import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/ui/button';
import { Settings2 } from 'lucide-react';
import { LegalLayout, LegalSection } from '../../components/LegalLayout';

/**
 * CookiePolicyPage — Cookie Policy dettagliata con categorie 3-tier.
 *
 * ★ 2026-08-27 (Phase 57.B) — Cookie policy i18n (IT/EN/ES) con CTA per
 * riaprire il banner delle preferenze cookie in qualsiasi momento.
 */
export default function CookiePolicyPage() {
  const { t } = useTranslation();

  const openPrefs = () => {
    // Trigger event: CookieBanner intercetta 'gp:open-cookie-prefs' e apre il modale.
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('gp:open-cookie-prefs'));
    }
  };

  return (
    <LegalLayout
      docType="cookiePolicy"
      title={t('legal.cookiePolicy.pageTitle', 'Cookie Policy')}
      intro={t('legal.cookiePolicy.intro', '')}
    >
      <LegalSection id="s1" title={t('legal.cookiePolicy.s1Title', '1. Cosa sono i cookie')}>
        {t('legal.cookiePolicy.s1Body', '')}
      </LegalSection>

      <LegalSection id="s2" title={t('legal.cookiePolicy.s2Title', '2. Cookie che utilizziamo')}>
        <div className="space-y-4 mt-2">
          <div className="p-3 rounded-lg border border-border bg-card">
            <div className="font-medium text-foreground text-sm">{t('legal.cookiePolicy.cat1Title', 'Cookie tecnici (essenziali)')}</div>
            <p className="text-xs text-muted-foreground mt-1 leading-relaxed">{t('legal.cookiePolicy.cat1Body', '')}</p>
          </div>
          <div className="p-3 rounded-lg border border-border bg-card">
            <div className="font-medium text-foreground text-sm">{t('legal.cookiePolicy.cat2Title', 'Cookie di analisi')}</div>
            <p className="text-xs text-muted-foreground mt-1 leading-relaxed">{t('legal.cookiePolicy.cat2Body', '')}</p>
          </div>
          <div className="p-3 rounded-lg border border-border bg-card">
            <div className="font-medium text-foreground text-sm">{t('legal.cookiePolicy.cat3Title', 'Cookie di marketing')}</div>
            <p className="text-xs text-muted-foreground mt-1 leading-relaxed">{t('legal.cookiePolicy.cat3Body', '')}</p>
          </div>
        </div>
      </LegalSection>

      <LegalSection id="s3" title={t('legal.cookiePolicy.s3Title', '3. Come gestirli')}>
        {t('legal.cookiePolicy.s3Body', '')}
        <div className="mt-4">
          <Button size="sm" variant="secondary" onClick={openPrefs} data-testid="cookie-policy-open-prefs">
            <Settings2 className="w-3.5 h-3.5 mr-1.5" />
            {t('legal.cookiePolicy.changePreferences', 'Cambia preferenze cookie')}
          </Button>
        </div>
      </LegalSection>
    </LegalLayout>
  );
}
